import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import FeatureIcon from "./FeatureIcon";

function NavAnchor({ href, children, onNavigate }) {
  const close = () => onNavigate?.();
  if (href?.startsWith("/") && !href.startsWith("//")) {
    return (
      <Link to={href} className="block py-2 text-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)]" onClick={close}>
        {children}
      </Link>
    );
  }
  return (
    <a href={href || "#"} className="block py-2 text-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)]" onClick={close}>
      {children}
    </a>
  );
}

export default function LandingMobileNav({ menu, links = [], nav }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <button
        type="button"
        className="lg:hidden inline-flex h-9 w-9 items-center justify-center rounded-md text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:bg-[var(--bg-elev)] transition-colors"
        aria-label="Open menu"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <Menu size={20} />
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent
          side="right"
          className="w-[min(100vw,20rem)] border-[var(--border-default)] bg-[var(--bg-surface)] text-[var(--text-primary)] overflow-y-auto"
        >
          <SheetTitle className="text-left font-heading text-base text-[var(--text-primary)] mb-4">Menu</SheetTitle>
          {menu?.columns?.length ? (
            <div className="space-y-6 mb-6">
              <p className="text-[10px] font-mono uppercase tracking-[0.18em] text-[var(--text-tertiary)]">
                {menu.label || "Products"}
              </p>
              {menu.columns.map((col) => (
                <div key={col.title}>
                  <p className="text-xs font-medium text-[var(--text-tertiary)] mb-2">{col.title}</p>
                  <div className="space-y-1">
                    {(col.links || []).map((item) => (
                      <NavAnchor key={item.label} href={item.href} onNavigate={close}>
                        <span className="flex items-center gap-2">
                          <FeatureIcon name={item.icon} size={16} className="text-[var(--primary)] shrink-0" />
                          {item.label}
                        </span>
                      </NavAnchor>
                    ))}
                  </div>
                </div>
              ))}
              {menu.seeAllHref ? (
                <NavAnchor href={menu.seeAllHref} onNavigate={close}>
                  <span className="text-xs font-mono text-[var(--primary)]">{menu.seeAllLabel || "See all products"} →</span>
                </NavAnchor>
              ) : null}
            </div>
          ) : null}
          {links.length > 0 ? (
            <div className="border-t border-[var(--border-default)] pt-4 space-y-1">
              {links.map((link) => (
                <NavAnchor key={link.href} href={link.href} onNavigate={close}>
                  {link.label}
                </NavAnchor>
              ))}
            </div>
          ) : null}
          <div className="mt-6 pt-4 border-t border-[var(--border-default)] flex flex-col gap-2">
            <Link to="/login" className="btn-ghost text-sm justify-center" onClick={close}>
              {nav?.loginLabel || "Log in"}
            </Link>
            <Link to={nav?.trialHref || "/signup"} className="btn-secondary text-sm justify-center" onClick={close}>
              {nav?.trialLabel || "Start free trial"}
            </Link>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
